package com.eladfinish.bible.contest.common.usecases

import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.constants.StringConstants.NUN_MENUZERET
import com.eladfinish.bible.contest.extensions.replaceRegex
import com.eladfinish.bible.contest.extensions.runIf

class RemoveTeamimUseCase {

    operator fun invoke(
        pasuk: String,
        isTikunKorim: Boolean = false,
    ): String =
        pasuk
            .replaceRegex(
                regex = StringConstants.Regex.TEAMIM_CHARS.runIf(condition = isTikunKorim) {
                    replace(oldValue = NUN_MENUZERET.toString(), newValue = "")
                },
                replacement = ""
            )
            .replaceRegex(
                regex = "${StringConstants.SPACE_OR_NO_BREAK_SPACE}+",
                replacement = " "
            )

}
